import React from "react";

const SubmissionSuccess = () => (
  <div>
    <h1 className="mt-5" style={{ textAlign: "center" }}>
      Your request has been submitted.
    </h1>
    <div className="row justify-content-center">
      <div className="col-auto alert alert-info alert-dismissible fade show mt-2" role="alert">
        We appreciate your feedback on whether the form was understandable 
        and efficient to complete. If you have comments,&nbsp;
        <a href="https://angelicshipping.com/Forms/ContactUs">
          <strong>please leave them here</strong>
        </a>
      </div>
    </div>
  </div>
);

export { SubmissionSuccess };